import * as Sentry from "@sentry/tanstackstart-react";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { useAuthStore } from "src/auth";

export const SentryUser = observer(function SentryUser() {
  const authStore = useAuthStore();
  const user = authStore.maybeUser;

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: user.id,
      email: user.email ?? undefined,
      username: user.name ?? undefined,
      role: user.role,
      tier: user.tier,
    });
  }, [user]);

  return null;
});
